import React,{useEffect, useState}from 'react'
import { message, List, Modal } from 'antd';
import CourseAdd from './CourseAdd';
import { useBnsJiaoChengKeShiDelMutation, useBnsJiaoChengKeShiListQuery,} from '../../store/ReactWebSiteApi';
import ModalDel from '../../cpn/ModalDel';
import CourseCheck from './CourseCheck';
import { PlusSquareOutlined } from '@ant-design/icons';
import CourseEdit from './CourseEdit';
function CourseList(props) {       
    const [open, setOpen] = useState(false);
    const [list, setList] = useState([]); 
    const {data, isSuccess} = useBnsJiaoChengKeShiListQuery({
        bjcks_bjc_id:props.bjc_id
    });    
    useEffect(() => {
        if (isSuccess) {
            console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bjcks_id:key,bjcks_name,bjcks_ctime,bjcks_cname,bjcks_jihua,bjcks_xuzhi,bxmbb_id,bg_name} = item;
                    return item = {key,bjcks_name,bjcks_ctime,bjcks_cname,bjcks_jihua,bjcks_xuzhi,bxmbb_id,bg_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.bjcks_ctime;
                    let bTimeString = b.bjcks_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)                
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   

    //删除
    const [del] = useBnsJiaoChengKeShiDelMutation()
    return (
        <>  
            <a onClick={() => {setOpen(true)}}><PlusSquareOutlined /> 课时</a> 
            <Modal
                open={open}
                title='课时'
                footer={null}
                onCancel={() => {setOpen(false);}}
                width={1000}
            >
                <div style={{textAlign:'right'}}>
                    <CourseAdd 
                        bjc_id={props.bjc_id}
                    />                
                </div>  
                {list && <List>
                                {list.map((item) => {
                                    return  <List.Item
                                                actions={[<ModalDel onOk={() => {
                                                    del({bjcks_id:item.key}).then((res) => {
                                                        console.log(res);
                                                        if (res.data.Status === 'success') {
                                                            message.success('删除成功！')                                                                              
                                                        }
                                                        if (res.data.Status === 'fail') {
                                                            message.error('删除失败！'+res.data.Message)
                                                        }
                                                    })
                                                }} />,
                                                <CourseEdit
                                                    bjcks_id={item.key}
                                                    bjc_id={props.bjc_id}
                                                />
                                             ]}
                                            >
                                            <CourseCheck
                                                    bjcks_id={item.key}
                                                    bjcks_name={item.bjcks_name}
                                                    bjc_id={props.bjc_id}
                                            />
                                            </List.Item>
                                })}
                            </List>}         
            </Modal>
        </>
    )
}

export default CourseList